import React from "react";
import { SketchPicker } from 'react-color';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
// @material-ui/icons
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import { MEMBER_SITE_ADDRESS } from "../../api-config";

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  exampleTrack: {
    color: 'red'
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle,
  ...sweetAlertStyle
};
var userUuid = sessionStorage.getItem('userUuid')

class WebSiteWidget extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')
    this.state = {
      userId: userId,
      buttonColor: '#005EA4',
      buttonFontColor: '#FFF',
      buttonText: 'join our membership program',
      colorType: 'B',
      copySuccess: ''
    };

  }
  componentDidMount() {
    this._isMounted = true;
  }

  constructWidget() {
    return "<input type='submit' onclick='window.open(\"" + MEMBER_SITE_ADDRESS + "/?providerId=" + userUuid + "\",\"_blank\")' style='background-color: " + this.state.buttonColor + "; color: " + this.state.buttonFontColor + "; border: none; border-radius: 30px; padding: 20px; font-size: 20px; display: inline-block; margin: 4px 2px;' value='" + this.state.buttonText + "' />"
  }

  handleChange(event, stateName) {
    this.setState({ [stateName]: event.target.value });
  };

  handleChangeComplete = (color) => {

    if (this.state.colorType === 'B') {
      this.setState({ buttonColor: color.hex });
    } else if (this.state.colorType === 'T') {
      this.setState({ buttonFontColor: color.hex });
    }

  };

  copyToClipboard = (e) => {

    var range = document.createRange();
    range.selectNode(document.getElementById("widgetToCopy"));
    window.getSelection().removeAllRanges(); // clear current selection
    window.getSelection().addRange(range); // to select text
    document.execCommand("copy");
    window.getSelection().removeAllRanges();// to deselect
    this.setState({ copySuccess: 'Copied!' });
  };

  render() {
    const { classes } = this.props;
    return (
      <div style={{width: '100%', align: 'center', height: '100%'}}>
        <GridContainer>
          {this.state.alert}
          <GridItem xs={12} sm={12}>
            Add a widget to your web site that allows patients to sign up for your membership program. Select a button color, text color and button text.
            Then, preview your button and copy the html code to place on your web site.
          </GridItem>
          <GridItem xs={12} sm={6}>
            <h3>edit widget</h3>
            <SketchPicker
              color={this.state.colorType === 'B' ? this.state.buttonColor : this.state.buttonFontColor}
              onChangeComplete={ this.handleChangeComplete }
              disableAlpha={true}
            />
            <FormControlLabel
              control={
                <Radio
                  checked={this.state.colorType=== "B"}
                  onChange={event => this.handleChange(event, "colorType", "colorType")}
                  value="B"
                  name="colorType"
                  aria-label="B"
                  icon={
                    <FiberManualRecord
                      className={classes.radioUnchecked}
                    />
                  }
                  checkedIcon={
                    <FiberManualRecord
                      className={classes.radioChecked}
                    />
                  }
                  classes={{
                    checked: classes.radio,
                    root: classes.radioRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label="background"
            />
            <FormControlLabel
              control={
                <Radio
                  checked={this.state.colorType=== "T"}
                  onChange={event => this.handleChange(event, "colorType", "colorType")}
                  value="T"
                  name="colorType"
                  aria-label="T"
                  icon={
                    <FiberManualRecord
                      className={classes.radioUnchecked}
                    />
                  }
                  checkedIcon={
                    <FiberManualRecord
                      className={classes.radioChecked}
                    />
                  }
                  classes={{
                    checked: classes.radio,
                    root: classes.radioRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label="text"
            />


            <CustomInput
              labelText={
                <span>
                  text
                </span>
              }
              id="buttonText"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                onChange: event => this.handleChange(event, "buttonText", "buttonText"),
                value: this.state.buttonText
              }}
            />

          </GridItem>
          <GridItem xs={12} sm={6}>
            <h3>preview and copy widget</h3>
            <input type="submit" style={{backgroundColor: this.state.buttonColor, color: this.state.buttonFontColor, border: 'none', borderRadius: '30px', padding: '20px', fontSize: '20px', display: 'inline-block', margin: '4px 2px'}} value={this.state.buttonText} />


            <div id="widgetToCopy">{this.constructWidget()}</div>


            <Button onClick={this.copyToClipboard} color="cirrusBlue">
              Copy button code
            </Button>


          </GridItem>
        </GridContainer>
      </div>

    );
  }
}

export default withStyles(style)(WebSiteWidget);
